<template>
    <div class="content-header">
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <h1 class="m-0 mr-4 font-weight-bold">
                        {{ nameBreadcrumbMain }}
                    </h1>
                    <ol class="breadcrumb font-weight-bold">
                        <li class="breadcrumb-item">
                            <a href="javascript:void(0)" @click="$router.push('/')">
                                <i class="el-icon-s-home"></i>
                                {{ $t('breadCrumb.home') }}
                            </a>
                        </li>
                        <li class="breadcrumb-item" v-if="menuFirst">
                            <a href="javascript:void(0)" @click="$router.push({ name: menuFirst.path })" v-if="menuSecond">
                                {{ $t(`breadCrumb.${menuFirst.label}`) }}
                            </a>
                            <span v-else>{{ nameBreadcrumbMain }}</span>
                        </li>
                        <li v-if="menuSecond" class="breadcrumb-item">
                            <a href="javascript:void(0)" @click="$router.push({ name: menuSecond.path })" v-if="menuThird">
                                {{ $t(`breadCrumb.${menuSecond.label}`) }}
                            </a>
                            <span v-else>{{ nameBreadcrumbMain }}</span>
                        </li>
                        <li v-if="menuThird" class="breadcrumb-item">
                            <a href="javascript:void(0)" @click="$router.push({ name: menuThird.path })" v-if="menuFourth">
                                {{ $t(`breadCrumb.${menuThird.label}`) }}
                            </a>
                            <span v-else>{{ nameBreadcrumbMain }}</span>
                        </li>
                        <li v-if="menuFourth" class="breadcrumb-item disabled-link">
                            <span>{{ $t(`breadCrumb.${menuFourth.label}`) }}</span>
                        </li>
                    </ol>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { MENUS } from '@/config/menusBreadcrum';

export default {
    name: 'breadCrumb',
    data: function () {
        return {
            menuItem: MENUS
        };
    },
    methods: {
        goPath(path) {
            if (path) {
                this.$router.push({ name: path });
            }
        },
        findActiveMenu(menu) {
            if (!menu) return null;

            let activeIndex = -1;
            for (let index in menu) {
                const menuItem = menu[index];
                if (Array.isArray(menuItem.pathActive) && menuItem.pathActive.includes(this.currentPath)) {
                    activeIndex = index;
                    break;
                }
            }

            if (activeIndex >= 0) {
                return menu[activeIndex];
            }

            return null;
        }
    },
    computed: {
        ...mapState(['currentPath']),
        menuFirst() {
            return this.findActiveMenu(this.menuItem, this.currentPath);
        },
        menuSecond() {
            const parentMenu = this.menuFirst?.subMenu;
            return this.findActiveMenu(parentMenu, this.currentPath);
        },
        menuThird() {
            const parentMenu = this.menuSecond?.subMenu;
            return this.findActiveMenu(parentMenu, this.currentPath);
        },
        menuFourth() {
            const parentMenu = this.menuThird?.subMenu;
            return this.findActiveMenu(parentMenu, this.currentPath);
        },
        nameBreadcrumbMain() {
            let pathChangeName = ['dataViewChildren'];
            if (this.$route.query.link_name && pathChangeName.includes(this.menuSecond.path)) {
                return this.$route.query.link_name;
            }
            if (this.menuFourth) {
                return this.$t(`breadCrumb.${this.menuFourth.label}`);
            }
            if (this.menuThird) {
                return this.$t(`breadCrumb.${this.menuThird.label}`);
            }
            if (this.menuSecond) {
                return this.$t(`breadCrumb.${this.menuSecond.label}`);
            }
            if (this.menuFirst) {
                return this.$t(`breadCrumb.${this.menuFirst.label}`);
            }
            return '';
        }
    }
};
</script>
<style lang="scss">
.content-header {
    @include Responsive(XS) {
        padding: 0rem;
    }
}
</style>
<style lang="scss" scoped></style>
